import { statisDimension } from '../const'

export default {
	filterArr: [
		{
			title: '统计维度',
			filterList: [
				{
					key: 'queryType',
					type: 'select',
					keyWord: '统计维度',
					multiple: false,
					needAll: false,
					clearable: false,
					options: statisDimension.alarmDeal,
					default: 0,
				},
			],
		},
		{
			title: '统计条件',
			filterList: [
				{
					key: 'manufacturerId',
					type: 'select',
					keyWord: '厂商名称',
				},
				{
					key: 'deviceTypeClassify',
					type: 'select',
					keyWord: '设备大类',
					tenantType: '0',
				},
				{
					key: 'deviceTypeIdList',
					dicKey: 'deviceTypeId',
					type: 'select',
					keyWord: '设备类型',
					tenantType: '0',
					filterable: true,
					multiple: true,
				},
				{
					key: 'userType',
					dicKey: 'userType',
					type: 'select',
					keyWord: '客户类型',
					tenantType: '1',
				},
				{
					key: 'alarmType',
					type: 'select',
					keyWord: '告警类型',
					filterable: true,
				},
				{
					key: 'dateSection',
					type: 'date',
					keyWord: '日期区间',
					icon: 'icon-shijian',
					datePickerType: 'datetimerange',
					clearable: false,
				},
			],
		},
	],
	columns: instance => {
		return [
			{
				key: 'deviceTypeName',
				name: '设备类型',
				hidden: instance.tenantType !== '0',
			},
			{
				key: 'userTypeName',
				name: '客户类型',
				hidden: instance.tenantType !== '1',
			},
			{
				key: 'alarmTypeName',
				name: '告警类型',
				hidden: instance.afterSearchParams.queryType === 1,
			},
			{
				key: 'date',
				name: '日期',
			},
			{
				key: 'alarmAmounts',
				name: '告警总量',
				hasTotal: true,
			},
			{
				key: 'treatedAmounts',
				name: '已处理量',
				hasTotal: true,
			},
			{
				key: 'untreatedAmounts',
				name: '未处理量',
				hasTotal: true,
			},
		].filter(m => !m.hidden)
	},
	header: {
		pic: 'statistical-analysis',
		title: '告警处理情况统计',
		desc: '对当前告警的处理情况进行统计分析。',
	},
}
